import gql from 'graphql-tag';

export const PERCEPTION_SURVEY_REPORT = gql`
  query getReportDataForRequestedUsersPerceptionSurvey($requestId: ID, $requestedUserId: ID) {
    getReportDataForRequestedUsersPerceptionSurvey(requestId: $requestId, requestedUserId: $requestedUserId)
  }
`;
